import Layout from '../components/Layout'
import SectionHeader from '../components/SectionHeader'
import { projects } from '../data/projects'

function Projects() {
  return (
    <Layout>
      <div className="pt-40 pb-32 md:pb-20">
        <SectionHeader
          subtitle="PROJECTS, 2021 — 2025"
          title="Some cool ideas brought <br /> to life through code."
        />

        <div className="grid grid-cols-2 gap-x-10 md:gap-x-24">
          {projects.map((project, index) => (
            <div
              key={index}
              className={`group cursor-pointer ${
                index % 2 === 0 ? 'mt-10 md:mt-32' : ''
              }`}
            >
              <div
                className="relative mb-4 overflow-hidden"
                style={{ aspectRatio: '4.5/5' }}
              >
                <div
                  className={`absolute inset-0 ${project.color} group-hover:scale-110 transition-transform duration-500 rounded-md`}
                >
                  {project.element}
                </div>
                <div className="absolute bottom-5 right-5 md:bottom-16 md:right-16">
                  <div className="relative">
                    <div className="w-12 h-12 md:w-28 md:h-28 rounded-full bg-white transform group-hover:scale-110 transition-transform duration-300" />
                    <div
                      className="absolute inset-0 flex items-center justify-center"
                      onClick={() => window.open(project.link, '_blank')}
                    >
                      <span className="text-2xl md:text-4xl font-light">↗</span>
                    </div>
                  </div>
                </div>
              </div>
              <h2 className="md:text-3xl font-medium md:pb-2">
                {project.title}
              </h2>
              <h2 className="text-sm md:text-xl md:pb-4 text-gray-400">
                {project.platform}
              </h2>
              <p className="text-sm md:text-xl text-gray-400">
                {project.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  )
}

export default Projects
